import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import * as api from 'Shared/api';
import RuleBuilder from './RuleBuilder';

const RuleBuilderEditForm = () => {
  const { id } = useParams();
  const [recommendationSetting, setRecommendationSetting] = useState(null);

  useEffect(() => {
    api.getCustomRecommendationSetting(id).then(response => {
      console.log('setRecommendationSetting from initial load');
      setRecommendationSetting(response.data);
    });
  }, [id]);

  if (!recommendationSetting) return null;

  return <RuleBuilder id={id} initialRecommendationSetting={recommendationSetting} />;
};

export default RuleBuilderEditForm;
